import React from "react";
import { Modal } from "antd";

const FileListModal = ({ files, isVisible, onClose }) => (
  <Modal
    title="Uploaded Files"
    open={isVisible}
    onCancel={onClose}
    footer={null}
  >
    <ul>
      {files.map((file, index) => (
        <li key={index}>{file.name}</li>
      ))}
    </ul>
  </Modal>
);

export default FileListModal;
